import { Card, CardContent, CardHeader } from '@billda/design-system';

export function UserPaymentDetailsEmptyCard() {
  return (
    <Card data-testid="user-payment-details-empty-card">
      <CardHeader>
        <h3 className="type-h6">Payment Details</h3>
      </CardHeader>
      <CardContent className="pt-3">
        <p className="type-body-md text-content-secondary">Not provided</p>
      </CardContent>
    </Card>
  );
}
